import { Injectable } from '@angular/core';

@Injectable()
export class DateParserService {

    public parseDate(date: Date): Date {
        return new Date(date.getFullYear() + '-' + this.twoDigit(date.getMonth() + 1) + '-' + this.twoDigit(date.getDate()) + 'T00:00:00.000Z');
    }

    private twoDigit(n: number): string {
        if (n > 9)
            return '' + n;
        else
            return '0' + n;
    }
}
